import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authData = this.getStoredAuthData();

    if (!authData?.success || !authData?.token || req.headers.has('Authorization')) {
      return next.handle(req);
    }

    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${authData.token}`,
      },
    });

    return next.handle(authReq);
  }

  private getStoredAuthData(): { success?: boolean; token?: string } | undefined {
    try {
      const storedValue = localStorage.getItem('AuthUser');
      if (!storedValue) {
        return undefined;
      }

      return JSON.parse(storedValue);
    } catch (error) {
      console.error('Unable to read stored auth data', error);
      return undefined;
    }
  }
}
